import { v4 as uuid } from 'uuid';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';

class BlockTableItemData {
  id: string;
  title: BlockComponentText;
  text: BlockComponentText;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockTableItemData {
  export function make(title: string, text: string): BlockTableItemData {
    return {
      id: uuid(),
      title: BlockComponentText.make(title),
      text: BlockComponentText.make(text),
    };
  }

  export function getDefault(
    title = '見出し',
    text = 'ここをクリックして表示したいテキストを入力してください。テキストは「太字」「文字サイズ」など編集することができます。',
  ): BlockTableItemData {
    return make(
      `<p><strong>${title}</strong></p>`,
      `<p>${text}</p>`,
    );
  }
}

export default BlockTableItemData;
